import { render, staticRenderFns } from "./stopWord.vue?vue&type=template&id=6b1863d7&"
import script from "./stopWord.vue?vue&type=script&lang=js&"
export * from "./stopWord.vue?vue&type=script&lang=js&"
import style0 from "./stopWord.vue?vue&type=style&index=0&id=6b1863d7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports